export enum UserStatus {
  Pending = 1,
  Invited = 2,
  Registered = 3,
  Visited = 4,
  NoAccess = 5,
  Active = 6,
  ActiveWithAccess = 7,
  Deleted = 8,
}

// export enum UserStatusName {
//   Pending = 'Pending',
//   Invited = 'Invited',
//   Registered = 'Registered',
//   Visited = 'Visited',
//   NoAccess = 'No Access',
//   Active = 'Active'
// }

export enum UserActivityStatus {
  Active = 1,
  InActive = 2,
  Deleted = 3,
  Pending = 4,
}
